export enum VideoTypeEnum {
    VideoStream,
    LiveStream
}